import { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import VuiInput from "components/VuiInput";

import AdminIntegrationCard from "./components/IntegrationCard";
import ConnectIntegrationDialog from "./components/ConnectIntegrationDialog";
import useCommon from "hooks/useCommon";
import { getIntegrations } from "store/slice/integrationsSlice";
import { CircularProgress } from "@mui/material";
import HotelSelector from "components/HotelSelector";
import { flexDirection } from "@mui/system";
import NoResults from "components/NoResult";

const AdminIntegrations = () => {
  const { STORE, DISPATCH } = useCommon();

  const [search, setSearch] = useState("");
  const [connectDialogOpen, setConnectDialogOpen] = useState(false);
  const [selectedIntegration, setSelectedIntegration] = useState(null);
  const [formValues, setFormValues] = useState({
    environment: "demo",
  });

  const { integrations, fetchLoading, fetchError, updateLoading } = STORE(
    (state) => state.integrations
  );
  const hotelId = STORE((state) => state.ui.hotelId);

  const handleConnectClick = (integration) => {
    setSelectedIntegration(integration);
    setFormValues({
      environment: integration.environment?.default || "demo",
    });
    setConnectDialogOpen(true);
  };

  const visibleIntegrations = integrations.filter(
    (i) => i.status === "enabled" && i.displayName.toLowerCase().includes(search.toLowerCase())
  );

  useEffect(() => {
    // if (integrations.length > 0) return;
    DISPATCH(getIntegrations(hotelId));
  }, [DISPATCH, hotelId]);

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <VuiBox py={1}>
        <VuiBox mb={1}>
          <Card>
            <VuiBox
              display="flex"
              flexWrap="wrap"
              gap={2}
              alignItems="flex-start"
              justifyContent="space-between"
            >
              {/* =====  Title + Subtitle ===== */}
              <VuiBox
                sx={{
                  width: { xs: "100%", md: "auto" },
                  textAlign: { xs: "left", md: "left" },
                }}
              >
                <VuiTypography variant="lg">Available Integrations</VuiTypography>

                <VuiTypography variant="caption" opacity={0.7} mt={0.5} display="block">
                  Connect external services to automate workflows
                </VuiTypography>
              </VuiBox>

              {/* ===== Search ===== */}
              <VuiBox
                display="flex"
                alignItems="center"
                gap={2}
                sx={{
                  width: { xs: "100%", md: "auto" },
                  justifyContent: { xs: "center", md: "flex-end" },
                  flexDirection: { xs: "column", md: "row" },
                }}
              >
                <HotelSelector />

                <VuiBox sx={{ width: { xs: "100%", sm: "200px" } }}>
                  <VuiInput
                    fullWidth
                    placeholder="Search integrations..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    gradient
                  />
                </VuiBox>
              </VuiBox>
            </VuiBox>

            {/* ===== Integrations ===== */}
            <VuiBox px={1} pb={3} mt={5}>
              <Grid container spacing={4}>
                {fetchLoading ? (
                  <VuiBox
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    width="100%"
                    minHeight="200px"
                  >
                    <CircularProgress size={40} color="primary" />
                  </VuiBox>
                ) : visibleIntegrations.length === 0 ? (
                  <Grid item xs={12}>
                    <NoResults title="No integrations found" search={search} />
                  </Grid>
                ) : (
                  visibleIntegrations.map((integration) => (
                    <Grid item xs={12} md={6} lg={4} key={integration._id}>
                      <AdminIntegrationCard
                        integration={integration}
                        onConnect={handleConnectClick}
                      />
                    </Grid>
                  ))
                )}
              </Grid>
            </VuiBox>
          </Card>
        </VuiBox>
        <ConnectIntegrationDialog
          open={connectDialogOpen}
          onClose={() => {
            setConnectDialogOpen(false);
            setSelectedIntegration(null);
          }}
          integration={selectedIntegration}
          values={formValues}
        />
      </VuiBox>
    </DashboardLayout>
  );
};

export default AdminIntegrations;
